/* eslint-disable indent */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */

import Add from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  AccessAlarm,
  AccountBox,
  Alarm,
  AttachMoney,
  AutoAwesome,
  Delete,
  Error,
  ExpandLess,
  ExpandMore,
  Group,
  InfoOutlined,
  LocationOn,
  MoneyOff,
  MoreVert,
  NoteAlt,
  PersonOff,
  Reorder,
  Schedule,
  Settings,
  Task,
} from '@mui/icons-material';
import {
  Chip,
  Collapse,
  Divider,
  Icon,
  IconButton,
  ListItemButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tooltip,
} from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import {
  alpha,
  useTheme,
} from '@mui/material/styles';
import moment from 'moment';
import BarnHorsesAutocomplete from '../../../../Autocompletes/BarnHorses';
import BarnUsersAutocomplete from '../../../../Autocompletes/BarnUsers';
import LocationsAutocomplete from '../../../../Autocompletes/Locations';
import UserMentionTextField from '../../../../UserMentionTextField';

import HorseIcon from '../../../../CustomIcons/Horse';
import Horse from '../../../../Horse';
import HorseTaskReminders, { HorseTaskReminderIndicator } from '../../../../HorseTaskReminders';

import {
  grey,
  primary,
  secondary,
} from '../../../../../utils/brandColors';
import { getBarnUsersForAssignmentString } from '../../../../../utils/scheduleHelper';
import useDebounce from '../../../../../utils/useDebounce';
import DueDate from '../../../../EventData/DueDate';
import HorseBillablePrice from '../../../../EventData/HorseBillablePrice';
import HorseNote from '../../../../EventData/HorseNote';
import LocationChip from '../../../../LocationChip';
import { getAvatarGroupForUsers } from '../../../../Planner/components/TaskCalendarOverview/components/TaskOverviewCell';
import { getStatusItemSecondaryText } from '../../../../StatusAssignment';
import TaskStatus from '../../../../TaskStatus';
import ScheduleParticipant from '../ScheduleParticipant';

const orderNumbers = Array.from({ length: 20 }, (_, i) => i + 1);

const TasksSection = ({
  schedule,
  event,
  eventTemplate,
  workflows: unorderedWorkflows,
  setWorkflows,
  validation,
  type,
  disabledForBeingInPast,
  isSaving,
  reminderRefreshKey,
  name,
  setName,
  setAssignment,
  restOfSuggestions,
  onRequestRemoveAllTasksForOccurrence,
}) => {
  const workflows = [...unorderedWorkflows].sort((a, b) => (a.eventDataDefaultValues['Display Order'] || 200) - (b.eventDataDefaultValues['Display Order'] || 200))
  const containerRef = React.useRef(null);

  const [selectedTaskAnchorEl, setSelectedTaskAnchorEl] = React.useState(false);
  const [initialWorkflowIndexSet, setInitialWorkflowIndexSet] = React.useState(false);
  const [selectedTaskIndex, setSelectedTaskIndex] = React.useState(-1);
  const [statusComment, setStatusComment] = React.useState('');
  const [otherHorseSuggestions, setOtherHorseSuggestions] = React.useState([]);
  const [orderMenunchorEl, setOrderMenuAnchorEl] = React.useState(null);
  const openOrderMenu = Boolean(orderMenunchorEl);

  const debouncedComment = useDebounce(statusComment, 500);
  const eventData = useSelector((state) => state.eventData.eventData);

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const locationsMap = useSelector((state) => state.location.locationsMap);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const statuses = useSelector((state) => state.status.statuses);
  const permissions = useSelector((state) => state.user.permissions);
  const showRemoveAllTasksForOccurrence = !!onRequestRemoveAllTasksForOccurrence && workflows.length > 1;

  const removeSelectedWorkflow = () => {
    const updatedWorkflows = workflows.filter((_, index) => index !== selectedTaskIndex);
    setWorkflows(updatedWorkflows);
    setSelectedTaskIndex(updatedWorkflows.length - 1);
    setSelectedTaskAnchorEl(null);
    setAssignment(updatedWorkflows.map((ww) => ww.scheduleAssignment || '').join(''));
  };

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;

  React.useEffect(() => {
    if (eventTemplate) {
      const otherHorsesWithSuggestions = [];

      const taskIdAsString = `${eventTemplate.id}`
      if (restOfSuggestions) {
        for (let i = 0; i < restOfSuggestions.length; i += 1) {
          if (restOfSuggestions[i].allSuggestions
            && restOfSuggestions[i].allSuggestions.find((t) => t === taskIdAsString)) {
            otherHorsesWithSuggestions.push(restOfSuggestions[i].barnHorse)
          }
        }
      }
      setOtherHorseSuggestions(otherHorsesWithSuggestions
        .filter((bh) => boardBarnHorses.find((bbh) => bh.pingumTagId === bbh.pingumTagId)
          && !workflows.find((w) => w.tagIds.find((t) => t === bh.pingumTagId))))
    }
  }, [restOfSuggestions, eventTemplate]);

  React.useEffect(() => {
    setSelectedTaskIndex(-1)
    setStatusComment('');
    setInitialWorkflowIndexSet(false);
    setOrderMenuAnchorEl(null);
  }, [schedule, event])

  React.useEffect(() => {
    if (selectedTaskIndex >= 0) {
      const updatedWorkflows = workflows;
      updatedWorkflows[selectedTaskIndex].startingStatusComment = debouncedComment;
      setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
    }
  }, [debouncedComment])

  React.useEffect(() => {
    if (!initialWorkflowIndexSet) {
      const selectedWorkflow = workflows && workflows[selectedTaskIndex];
      if (!workflows || workflows.length === 0 || (selectedWorkflow && !workflows.find((w) => (`${w.tagIds}`) === (`${selectedWorkflow.tagIds}`)))) {
        // Remove selected workflow
        setSelectedTaskIndex(-1);
      } else if (workflows && workflows.length > 0 && selectedTaskIndex < 0
        && workflows.find((w) => w.tagIds.length <= 0)) {
        // find selected if passed in
        setSelectedTaskIndex(workflows.findIndex((w) => w.tagIds.length <= 0));
      }
      // else {
      //   // Default to the last index
      //   setSelectedTaskIndex(workflows.length - 1);
      // }
      setInitialWorkflowIndexSet(true);
    }
  }, [workflows])

  const setWorkflowDisplayOrder = (e, index) => {
    const updatedWorkflows = workflows;
    updatedWorkflows[index].eventDataDefaultValues = {
      ...updatedWorkflows[index].eventDataDefaultValues,
      'Display Order': e.target.value < 0
        ? null
        : e.target.value,
    }
    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
    setSelectedTaskIndex(-1);
    setOrderMenuAnchorEl(null)
    e.stopPropagation();
  }

  // const horseTagTypeId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0;
  const horseTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTaskTypeTagId) || 0;
  const barnTaskTypeTagId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.barnTaskTypeTagId) || 0;

  const eventTemplateTags = (eventTemplate && eventTemplate.tags) || [];
  const horseTaskTypeTag = eventTemplateTags.filter((t) => t.id === horseTaskTypeTagId).length > 0
    ? eventTemplateTags.filter((t) => t.id === horseTaskTypeTagId)[0]
    : null;
  const barnTaskTypeTag = eventTemplateTags.filter((t) => t.id === barnTaskTypeTagId).length > 0
    ? eventTemplateTags.filter((t) => t.id === barnTaskTypeTagId)[0]
    : null;

  if (!eventTemplate || !eventTemplate.id) return <div />;

  const w = workflows[selectedTaskIndex];
  const workflowStatus = statuses
    .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusId)))
  const workflowStatusComment = selectedTaskIndex >= 0 && workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingStatusComment
  const theme = useTheme();
  const headerAccentColor = validation.workflows
    ? theme.palette.error.main
    : theme.palette.primary.main;
  const headerTextColor = theme.palette.getContrastText
    ? theme.palette.getContrastText(headerAccentColor)
    : '#fff';

  const listItemSx = {
    px: 1,
    py: 0.75,
  };
  const listItemIconSx = {
    minWidth: 32,
    mr: 0.75,
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
      height: '1.25rem',
      width: '1.25rem',
    },
  };

  const reminderPairs = workflows.flatMap((workflow) => {
    if (!horseTaskTypeTag || workflow.tagIds?.length !== 1) return [];
    const tagId = workflow.tagIds[0];
    const horse = (barnHorsesMap[tagId] || []).find((candidate) => Number(candidate.pingumTagId) === Number(tagId));
    if (!horse) return [];
    return [{
      tagId: horse.pingumTagId,
      eventTemplateId: eventTemplate.id,
    }];
  });

  const taskContent = (
    <Grid
      container
      sx={{
        mb: 2,
        pr: 2,
      }}
      spacing={2}
      ref={containerRef}
    >
      <Grid size={12}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 1,
            p: 1,
            color: headerTextColor,
            backgroundImage: `linear-gradient(120deg, ${headerAccentColor}, ${alpha(headerAccentColor, 0.8)})`,
            // boxShadow: `0 18px 42px ${alpha(headerAccentColor, 0.35)}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                backgroundColor: alpha(theme.palette.common.black, 0.1),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Task sx={{ color: headerTextColor }} />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ mb: 0.25 }}>
                Tasks
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                {workflows.length} {horseTaskTypeTag
                  ? 'horse task'
                  : 'location task'}{workflows.length === 1
                    ? ''
                    : 's'} scheduled
              </Typography>
            </Box>
          </Stack>
          <Tooltip
            title={`Add Another ${horseTaskTypeTag
              ? 'Horse'
              : 'Location'} Task`}
          >
            <span>
              <IconButton
                disabled={workflows.length > 0 && !!workflows.find((ww) => !ww.tagIds || ww.tagIds.length === 0)}
                onClick={() => {
                  if (!workflows.find((ww) => ww.tagIds.length === 0)) {
                    // Only add if there are no other empty tasks
                    setSelectedTaskIndex(workflows.length)
                    setWorkflows([...workflows, {
                      eventTemplateId: eventTemplate.id,
                      tagIds: [],
                      createEvents: true,
                      startingAssignment: '',
                      dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                      dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                      dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                      eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                    }])
                  }
                }}
                sx={{
                  backgroundColor: alpha(theme.palette.common.white, 0.12),
                  color: headerTextColor,
                  '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.2) },
                  '&:disabled': {
                    opacity: 0.5,
                    color: headerTextColor,
                  },
                }}
              >
                <Add />
              </IconButton>
            </span>
          </Tooltip>
        </Paper>
      </Grid>
      {
        workflows.map((workflow, index) => {
          const ws = statuses
            .find((s) => s.id === ((index >= 0 && workflow.startingStatusId)))
          const wsc = index >= 0 && workflow.startingStatusComment
          const barnHorse = horseTaskTypeTag
            && ((workflow.tagIds && workflow.tagIds.length === 1 && barnHorsesMap[workflow.tagIds[0]]
              && barnHorsesMap[workflow.tagIds[0]].find((horse) => Number(horse.pingumTagId) === Number(workflow.tagIds[0]))) || null)
          const location = !barnHorse && barnTaskTypeTag
            && ((workflow.tagIds && workflow.tagIds.length === 1 && locationsMap[workflow.tagIds[0]]
              && locationsMap[workflow.tagIds[0]][0]) || null);
          const color = (eventTemplate.eventDataDefaultValues
            && eventTemplate.eventDataDefaultValues.calendarDisplayColor)
            || primary.main

          const dueDateTime = workflow.dueDateTime || 0
          const dueDateTimeEndOfDay = workflow.dueDateTimeEndOfDay || false;
          const billableValue = (workflow.eventDataDefaultValues
            || {})[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)];
          const billableReceivable = (workflow.eventDataDefaultValues || {})['Billable Receivable'] || 'yes';
          // const billableStatus = (workflow.eventDataDefaultValues || {})['Billable Status'] || 'Open';
          const horseNote = workflow.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]
          return (
            <Grid key={`workflow-container-${(workflow.tagIds && workflow.tagIds.join('')) || '0'}-${index}`} size={12}>
              <Paper
                elevation={2}
                sx={{
                  padding: 1,
                  borderLeft: `8px solid ${color}`,
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    '&:hover': {
                      opacity: '75%',
                      cursor: 'pointer',
                    },
                  }}
                  onClick={() => {
                    setSelectedTaskIndex(selectedTaskIndex === index
                      ? -1
                      : index);
                  }}
                >
                  <Box
                    sx={{
                      pr: 1,
                      mr: 1,
                      borderRight: `1px solid ${'var(--blueGrey-unknown)'}`,
                    }}
                    style={{ '--blueGrey-unknown': blueGrey[50] }}
                  >
                    {
                      !barnHorse && !location && (
                        <Error
                          color={
                            validation.workflows
                              ? 'error'
                              : 'warning'
                          }
                        />
                      )
                    }
                    {barnHorse
                      && (
                        <Stack spacing={0.5} alignItems="flex-start">
                          <Horse horse={barnHorse.horse} />
                          <HorseTaskReminderIndicator tagId={barnHorse.pingumTagId} eventTemplateId={eventTemplate.id} />
                        </Stack>
                      )}
                    {location && (
                      <Box>
                        <LocationChip
                          location={location}
                        />
                      </Box>
                    )}
                  </Box>
                  <Grid container spacing={1} alignItems="center" sx={{ flex: 1 }} justifyContent="flex-end" flexWrap="wrap">
                    {
                      workflows[index] && workflows[index].eventDataDefaultValues && (
                        <Grid>
                          <Tooltip placement="left" title="Barn Board Task Display Order">
                            <IconButton
                              onClick={(e) => {
                                setOrderMenuAnchorEl(e.currentTarget);
                                e.stopPropagation();
                              }}
                              size="small"
                            >
                              {workflows[index].eventDataDefaultValues['Display Order'] || <Reorder color="secondary" />}
                            </IconButton>
                          </Tooltip>
                          <Menu
                            id="basic-menu"
                            anchorEl={orderMenunchorEl}
                            open={openOrderMenu}
                            onClose={() => setOrderMenuAnchorEl(null)}
                            onClick={(e) => setWorkflowDisplayOrder(e, index)}
                            value={workflows[index].eventDataDefaultValues['Display Order'] || -1}
                          >
                            <MenuItem
                              key="order-item-null"
                              value={-1}
                            />
                            {
                              orderNumbers.map((item) => (
                                <MenuItem
                                  key={`order-item-${item}`}
                                  value={item}
                                >{item}
                                </MenuItem>
                              ))
                            }
                          </Menu>
                        </Grid>
                      )
                    }

                    {
                      !!dueDateTime
                      && (
                        <Grid>
                          <Tooltip
                            title={
                              dueDateTimeEndOfDay
                                ? 'Complete this task by end of day'
                                : `Complete this task by ${moment(new Date(new Date().getTime() + dueDateTime)).fromNow().replace('in ', '')} from start`
                            }
                          >
                            <Alarm color="secondary" />
                          </Tooltip>
                        </Grid>
                      )
                    }
                    {
                      horseNote && (
                        <Grid>
                          <Tooltip title="Creates a note on horse profile">
                            <NoteAlt color="secondary" />
                          </Tooltip>
                        </Grid>
                      )
                    }
                    {
                      billableValue && (
                        <Grid>
                          <Tooltip title={`Creates a billing transaction on horse: $${billableValue}`}>
                            {
                              billableReceivable === 'yes'
                                ? <AttachMoney color="success" />
                                : <MoneyOff color="secondary" />
                            }
                          </Tooltip>
                        </Grid>
                      )
                    }

                    {
                      ((ws && ws.id !== selectedBarn.barnMetadata.statusStartId) || wsc) && (
                        <Grid>
                          <Chip
                            size="small"
                            color="primary"
                            icon={
                              (ws || wsc)
                                ? (
                                  <Icon
                                    sx={{ fontSize: '18px' }}
                                    color="primary"
                                  >{(ws && ws.icon) || eventTemplate.defaultStartStatus.icon}
                                  </Icon>
                                )
                                : (<Schedule sx={{ fontSize: '18px' }} color="primary" />)
                            }
                            label={(ws && ws.name) || (event && 'Scheduled') || 'Pending'}
                          />
                        </Grid>
                      )
                    }
                    {
                      workflow.scheduleAssignment && (
                        <Grid>
                          <Tooltip title="Task Participants">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                border: `1px solid ${'var(--secondary-unknown)'}`,
                                borderRadius: 20,
                                gap: 0.5,
                              }}
                              style={{ '--secondary-unknown': secondary[500] }}
                            >
                              <Group color="secondary" sx={{ paddingLeft: '2px' }} />
                              {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.scheduleAssignment || '', barnUsersMap), '')}
                            </Box>
                          </Tooltip>
                        </Grid>
                      )
                    }
                    <Grid>
                      <Tooltip
                        title={workflow.startingAssignment
                          ? 'Task Assignment'
                          : 'Unassigned Task'}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {getAvatarGroupForUsers(getBarnUsersForAssignmentString(workflow.startingAssignment || '', barnUsersMap), '')}
                          {
                            !workflow.startingAssignment && <PersonOff color="secondary" />
                          }
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid>
                      {selectedTaskIndex === index
                        ? <ExpandLess />
                        : <ExpandMore />}
                    </Grid>
                  </Grid>
                </Box>
                {
                  selectedTaskIndex === index && (
                    <Collapse in={selectedTaskIndex === index}>
                      <Box sx={{ height: '100%' }}>
                        <ListItemText
                          sx={{
                            backgroundColor: grey[50],
                            borderRadius: 4,
                            mt: 2,
                            mb: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <TaskStatus
                              eventStatus={{
                                assignment: (workflows[selectedTaskIndex] && workflows[selectedTaskIndex].startingAssignment) || '',
                                statusComment: workflowStatusComment,
                                status: workflowStatus || {
                                  ...statuses.find((s) => s.id === selectedBarn.barnMetadata.statusStartId),
                                  name: 'Scheduled Task',
                                  statusIcon: 'schedule',
                                },
                              }}
                              icon={(workflowStatus && workflowStatus.icon) || 'schedule'}
                              color={primary[500]}
                              archived={false}
                              complete={!!(workflowStatus && workflowStatus.completeEvent)}
                              scheduled
                            />
                            <Button
                              size="small"
                              sx={{ mr: 2 }}
                              endIcon={<MoreVert />}
                              onClick={(e) => {
                                setSelectedTaskAnchorEl(e.currentTarget);
                                setStatusComment(workflows[selectedTaskIndex].startingStatusComment || '')
                              }}
                              disabled={disabledForBeingInPast}
                            >
                              Actions
                            </Button>
                          </Box>
                        </ListItemText>
                        <ListItem dense sx={listItemSx}>
                          <ListItemIcon sx={listItemIconSx}>
                            {horseTaskTypeTag
                              ? <HorseIcon />
                              : <LocationOn />}
                          </ListItemIcon>
                          <ListItemText>
                            {horseTaskTypeTag
                              ? (
                                <BarnHorsesAutocomplete
                                  multiple={false}
                                  validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                    ? validation.workflows
                                    : ''}
                                  value={(w.tagIds && workflow.tagIds.length === 1
                                    && barnHorsesMap[w.tagIds[0]] && barnHorsesMap[w.tagIds[0]][0]) || null}
                                  onSelect={(e, newHorse) => {
                                    // take selected barn horses and map to tags
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].tagIds = newHorse
                                      ? [parseInt(newHorse.pingumTagId, 10)]
                                      : [];
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  limitTags={1}
                                  barnHorses={boardBarnHorses && boardBarnHorses.length > 0
                                    ? boardBarnHorses.filter((bh) => !workflows || !workflows.find((ww) => `${ww.tagIds[0]}` === `${bh.pingumTagId}`))
                                    : undefined}
                                  disabled={disabledForBeingInPast}
                                />
                              )
                              : (
                                <LocationsAutocomplete
                                  multiple={false}
                                  validation={((w.tagIds === null || workflow.tagIds.length === 0) && validation.workflows)
                                    ? validation.workflows
                                    : ''}
                                  value={(w.tagIds && workflow.tagIds.length === 1
                                    && locationsMap[w.tagIds[0]] && locationsMap[w.tagIds[0]][0]) || null}
                                  onSelect={(e, newLocations) => {
                                    // take selected locations and map to tags
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].tagIds = newLocations
                                      ? [parseInt(newLocations.pingumTagId, 10)]
                                      : [];
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  size="small"
                                  limitTags={1}
                                  disabled={disabledForBeingInPast}
                                />
                              )}
                          </ListItemText>
                        </ListItem>
                        <ListItem dense sx={listItemSx}>
                          <ListItemIcon sx={listItemIconSx}><AccountBox /></ListItemIcon>
                          <ListItemText>
                            <BarnUsersAutocomplete
                              label="Assigned User"
                              id={`tag-assign-user-${w.tagIds}`}
                              multiple
                              blurOnSelect
                              value={getBarnUsersForAssignmentString(w.startingAssignment || '', barnUsersMap)}
                              onSelect={(e, newBarnUsers) => {
                                // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                                const updatedWorkflows = workflows;
                                updatedWorkflows[selectedTaskIndex].startingAssignment = newBarnUsers.map((bu) => (bu.id
                                  ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                                  : `@[${bu.userFullName || bu}](${null})`)).join('');
                                setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                              }}
                              limitTags={1}
                              disabled={disabledForBeingInPast}
                              suggestAssignmentHorseTagId={barnHorse && barnHorse.pingumTagId}
                              clientAccessHorseId={barnHorse && barnHorse.horse.id}
                            />
                          </ListItemText>
                          <Tooltip title="Assigned users are responsible for doing any work associated with and completing the task in Questri. These users will see the task on their task list in the mobile app and barn board.">
                            <InfoOutlined
                              sx={{
                                ml: 1,
                                fontSize: 20,
                              }}
                              color="secondary"
                            />
                          </Tooltip>
                        </ListItem>
                        <ScheduleParticipant
                          schedule={schedule}
                          event={event}
                          blurOnSelect
                          validation={validation}
                          assignment={w.scheduleAssignment}
                          setAssignment={(newAssignment) => {
                            const updatedWorkflows = workflows;
                            updatedWorkflows[selectedTaskIndex].scheduleAssignment = newAssignment;

                            // make sure each workflow assignment is added to schedule assignment
                            setAssignment(updatedWorkflows.map((ww) => ww.scheduleAssignment || '').join(''));

                            // Now assign to the workflow
                            setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                          }}
                          type={type}
                          name={name}
                          setName={setName}
                          disabledForBeingInPast={disabledForBeingInPast}
                          suggestParticipantHorseTagId={barnHorse && barnHorse.pingumTagId}
                          clientAccessHorseId={barnHorse && barnHorse.horse.id}
                        />
                        <ListItem dense sx={listItemSx}>
                          <ListItemIcon sx={listItemIconSx}><AccessAlarm /></ListItemIcon>
                          <ListItemText>
                            <DueDate
                              workflows={workflows}
                              setWorkflows={setWorkflows}
                              selectedTaskIndex={selectedTaskIndex}
                              entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                            />
                          </ListItemText>
                        </ListItem>

                        {
                          horseTaskTypeTag && (
                            <ListItem dense sx={listItemSx}>
                              <ListItemIcon sx={listItemIconSx}><AttachMoney /></ListItemIcon>
                              <ListItemText>
                                <HorseBillablePrice
                                  onChange={(newEventDataDefaults) => {
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                  showHeader={false}
                                  type="inline"
                                  entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                />
                              </ListItemText>
                            </ListItem>
                          )
                        }

                        {
                          horseTaskTypeTag && (
                            <ListItem dense sx={listItemSx}>
                              <ListItemIcon sx={listItemIconSx}><NoteAlt /></ListItemIcon>
                              <ListItemText>
                                <HorseNote
                                  onChange={(newEventDataDefaults) => {
                                    const updatedWorkflows = workflows;
                                    updatedWorkflows[selectedTaskIndex].eventDataDefaultValues = newEventDataDefaults;
                                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                                  }}
                                  eventDataDefaultValues={workflows[selectedTaskIndex].eventDataDefaultValues}
                                  showHeader={false}
                                  type="inline"
                                  entityIdentifier={`${workflows[selectedTaskIndex].taskIds}`}
                                />
                              </ListItemText>
                            </ListItem>
                          )
                        }
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            mt: 1,
                          }}
                        >
                          <Button
                            color="secondary"
                            size="small"
                            onClick={removeSelectedWorkflow}
                          >
                            Remove {horseTaskTypeTag
                              ? 'Horse'
                              : 'Location'}
                          </Button>
                          {showRemoveAllTasksForOccurrence && (
                            <Button
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedTaskAnchorEl(null);
                                onRequestRemoveAllTasksForOccurrence();
                              }}
                            >
                              Remove All
                            </Button>
                          )}
                        </Box>
                      </Box>
                    </Collapse>
                  )
                }
              </Paper>
            </Grid>
          );
        })
      }
      {
        otherHorseSuggestions.length > 0 && (
          <Grid size={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mt: 2,
              }}
            >
              <AutoAwesome sx={{ color: '#FF6600 !important' }} />
              <Typography
                sx={{ ml: 1 }}
              >
                Other Horses Suggesting This Task
              </Typography>
            </Box>
            <Grid container spacing={1}>
              {otherHorseSuggestions.map((bh) => (
                <Grid key={`suggestion-horse-${bh.id}`}>
                  <Horse
                    chip
                    horse={bh.horse}
                    clickable
                    onClick={() => {
                      // check for duplicates
                      if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(bh.pingumTagId, 10)]}`)) {
                        return; // Don't allow duplicate
                      }

                      setWorkflows(JSON.parse(JSON.stringify([...workflows, {
                        eventTemplateId: eventTemplate.id,
                        tagIds: [parseInt(bh.pingumTagId, 10)],
                        createEvents: true,
                        startingAssignment: '',
                        dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                        dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                        dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                        eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                      }]))); // force react to refresh
                      setOtherHorseSuggestions(otherHorseSuggestions.filter((h) => h.id !== bh.id))
                      if (containerRef.current) {
                        setTimeout(() => {
                          containerRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'end',
                          }); // Scroll to the bottom
                        }, 100)
                      }
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        )
      }
      <Grid size={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 4,
            px: 8,
          }}
        >

          <Tooltip
            title={`Select ${horseTaskTypeTag
              ? 'Horse'
              : 'Location'} to add another Task`}
            placement="left"
          >
            <Box sx={{ width: '100%' }}>
              {horseTaskTypeTag
                ? (
                  <BarnHorsesAutocomplete
                    multiple
                    label="Add Horse(s)"
                    showAdornment
                    value={[]}
                    onSelect={(e, newHorses) => {
                      // check for duplicates
                      if (newHorses && newHorses.length === 1) {
                        if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(newHorses[0].pingumTagId, 10)]}`)) {
                          return; // Don't allow duplicate
                        }

                        const newWorkflows = JSON.parse(JSON.stringify([...workflows, {
                          eventTemplateId: eventTemplate.id,
                          tagIds: [parseInt(newHorses[0].pingumTagId, 10)],
                          createEvents: true,
                          startingAssignment: '',
                          dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                          dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                          dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                          eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                        }])) // force react to refresh
                        setWorkflows(newWorkflows);
                        if (containerRef.current) {
                          setTimeout(() => {
                            containerRef.current.scrollIntoView({
                              behavior: 'smooth',
                              block: 'end',
                            }); // Scroll to the bottom
                          }, 100)
                        }
                      }
                    }}
                    limitTags={1}
                    barnHorses={boardBarnHorses && boardBarnHorses.length > 0
                      ? boardBarnHorses.filter((bh) => !workflows || !workflows.find((ww) => `${ww.tagIds[0]}` === `${bh.pingumTagId}`))
                      : undefined}
                  />
                )
                : (
                  <LocationsAutocomplete
                    multiple={false}
                    label="Add Location"
                    validation={validation.workflows && 'At least one task is required'}
                    value={null}
                    showAdornment
                    onSelect={(e, newLocations) => {
                      // check for duplicates
                      if (workflows.find((ww) => `${ww.tagIds}` === `${[parseInt(newLocations.pingumTagId, 10)]}`)) {
                        return; // Don't allow duplicate
                      }
                      setWorkflows(JSON.parse(JSON.stringify([...workflows, {
                        eventTemplateId: eventTemplate.id,
                        tagIds: [parseInt(newLocations.pingumTagId, 10)],
                        createEvents: true,
                        startingAssignment: '',
                        dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId,
                        dueDateTime: eventTemplate.dueDateDefaultTime || 0,
                        dueDateTimeEndOfDay: eventTemplate.dueDateDefaultTimeEndOfDay || false,
                        eventDataDefaultValues: eventTemplate.eventDataDefaultValues || {},
                      }]))); // force react to eventTemplate
                    }}
                    size="small"
                    limitTags={1}
                  />
                )}

            </Box>
          </Tooltip>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: 2,
            px: 8,
          }}
        >
          <Box sx={{ width: '100%' }}>
            <Tooltip title="Assign all tasks to a user" placement="left">
              <Box>
                <BarnUsersAutocomplete
                  id="assign-all-tasks-user"
                  label="Assign Task(s)"
                  multiple={false}
                  showAdornment
                  blurOnSelect
                  value={null}
                  onSelect={(e, newBarnUser) => {
                    // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                    const updatedWorkflows = workflows;
                    for (let i = 0; i < updatedWorkflows.length; i += 1) {
                      updatedWorkflows[i].startingAssignment = newBarnUser.id
                        ? `@[${newBarnUser.userFullName}](${newBarnUser.auth0UserId || newBarnUser.email})`
                        : `@[${newBarnUser.userFullName || newBarnUser}](${null})`;
                    }
                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                  }}
                  limitTags={1}
                  disabled={disabledForBeingInPast}
                />
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Grid>
      <Menu
        id="menu-appbar"
        anchorEl={selectedTaskAnchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={!!selectedTaskAnchorEl}
        onClose={() => {
          if (statuses
            .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
              || eventTemplate.defaultStartStatus.id)).requireComment && !statusComment) {
            return;
          }
          setSelectedTaskAnchorEl(null);
        }}
      >
        <MenuItem>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <TextField
                select
                label="Task Status"
                name="status"
                id="status-select"
                variant="outlined"
                size="small"
                fullWidth
                value={(selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate && eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)}
                onChange={(e) => {
                  if (e.target.value === -1) {
                    window.location.href = '/settings/tasks/statuses'
                  } else {
                    const updatedWorkflows = workflows;
                    updatedWorkflows[selectedTaskIndex].startingStatusId = e.target.value;
                    setWorkflows(JSON.parse(JSON.stringify(updatedWorkflows))); // force react to refresh
                  }
                }}
                SelectProps={{
                  renderValue: () => {
                    const status = statuses
                      .find((s) => s.id === ((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || eventTemplate.defaultStartStatus.id));
                    return (
                      <ListItem sx={{ p: 0 }} dense>
                        <Icon
                          sx={{
                            color: primary[500],
                            mr: 2,
                          }}
                        >{status.icon}
                        </Icon>
                        <ListItemText
                          primary={status.name}
                          secondaryTypographyProps={{ component: 'div' }}
                          secondary={getStatusItemSecondaryText(status, {})}
                        />
                      </ListItem>
                    )
                  },
                }}
              >
                {
                  statuses.sort((a, b) => a.statusOrder - b.statusOrder).map((status) => (
                    <ListItemButton
                      dense
                      key={`status-${status.id}`}
                      value={status.id}
                      button={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) !== status.id}
                      disabled={((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id)) === status.id}
                    >
                      <Icon
                        sx={{
                          mr: 1,
                          color: primary[500],
                        }}
                      >{status.icon}
                      </Icon>
                      <ListItemText
                        primary={status.name}
                        secondaryTypographyProps={{ component: 'div' }}
                        secondary={getStatusItemSecondaryText(status, {})}
                      />
                    </ListItemButton>
                  ))
                }

                {(permissions.admin || permissions.owner) && (
                  <Divider />
                )}
                {(permissions.admin || permissions.owner) && (
                  <ListItemButton
                    dense
                    value={-1}
                  >
                    <Settings color="secondary" sx={{ mr: 1 }} />
                    <ListItemText
                      primary="Manage available task statuses"
                      secondary="Selecting this will take you away from this page, and any changes won't be saved."
                    />
                  </ListItemButton>
                )}
              </TextField>
              <Tooltip title="Done editing status">
                <span>
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={statuses
                      .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                        || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
                    onClick={() => { setSelectedTaskAnchorEl(null); }}
                  >
                    Done
                  </Button>
                </span>
              </Tooltip>
            </Box>
            <UserMentionTextField
              value={statusComment}
              label="Task Status Comment"
              rows={2}
              onChange={(e) => setStatusComment(e.target.value)}
              required={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment}
              error={statuses
                .find((s) => s.id === (((selectedTaskIndex >= 0 && workflows[selectedTaskIndex].startingStatusId)
                  || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id))) || {}).requireComment && !statusComment}
              helperText="Leave a comment or message on this task."
            />
          </Box>

        </MenuItem>
        <Divider sx={{ my: 1 }} />
        <MenuItem
          onClick={removeSelectedWorkflow}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          Remove {horseTaskTypeTag
            ? 'Horse'
            : 'Location'}
        </MenuItem>
        {showRemoveAllTasksForOccurrence && (
          <MenuItem
            onClick={() => {
              setSelectedTaskAnchorEl(null);
              onRequestRemoveAllTasksForOccurrence();
            }}
          >
            <ListItemIcon>
              <Delete color="error" />
            </ListItemIcon>
            Remove All {horseTaskTypeTag
              ? 'Horses'
              : 'Locations'} For This Occurrence
          </MenuItem>
        )}
      </Menu>
    </Grid>
  );

  return (
    <HorseTaskReminders pairs={reminderPairs} disabled={isSaving} refreshKey={reminderRefreshKey}>
      {taskContent}
    </HorseTaskReminders>
  );
};

TasksSection.propTypes = {
  eventTemplate: PropTypes.object,
  schedule: PropTypes.object,
  event: PropTypes.object,
  workflows: PropTypes.array,
  validation: PropTypes.object.isRequired,
  setWorkflows: PropTypes.func,
  disabledForBeingInPast: PropTypes.bool,
  isSaving: PropTypes.bool,
  reminderRefreshKey: PropTypes.string,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  setAssignment: PropTypes.func,
  restOfSuggestions: PropTypes.array,
  onRequestRemoveAllTasksForOccurrence: PropTypes.func,

};

TasksSection.defaultProps = {
  eventTemplate: {},
  schedule: {},
  event: {},
  workflows: [],
  setWorkflows: () => { },
  disabledForBeingInPast: false,
  isSaving: false,
  reminderRefreshKey: '',
  setAssignment: () => { },
  restOfSuggestions: [],
  onRequestRemoveAllTasksForOccurrence: null,
};

export default TasksSection;
